module.exports = __webpack_public_path__ + "images/kihnu/apple-icon-120x120.png";